import React from 'react';
import PropTypes from 'prop-types';
import CommentItem from './comment-item';
var CommentList = function (_ref) {
  var _ref$comments = _ref.comments,
    comments = _ref$comments === void 0 ? [] : _ref$comments,
    parentCommentId = _ref.parentCommentId,
    updateCommentform = _ref.updateCommentform;
  return /*#__PURE__*/React.createElement("ul", {
    className: "p-commentsTable"
  }, comments.map(function (comment) {
    return /*#__PURE__*/React.createElement(CommentItem, {
      key: comment.id,
      comment: comment,
      id: comment.id,
      parentCommentId: parentCommentId,
      updateCommentform: updateCommentform
    });
  }));
};
CommentList.propTypes = {
  comments: PropTypes.array
};
export default CommentList;